import { combineReducers } from 'redux'
import all from './all'
import byEntity from './byEntity'


export default combineReducers({ all, byEntity })
